<!--
    Alternador de tema claro/escuro, no topo (depois do Monitoramento) e no menu mobile.

    Mesmo botao do Bluve e do Moub: sol ambar no claro, meia-lua no escuro. O clique
    aplica na hora (classe `dark` no <html> + localStorage). Ver ThemeService.
-->
<template>
    <button type="button" class="theme-toggle"
        :class="{ 'is-dark': isDark }"
        :title="label"
        :aria-label="label"
        :aria-pressed="isDark ? 'true' : 'false'"
        @click="toggle()">
        <!-- Um SVG so, com as duas formas sobrepostas: a troca e uma transicao de
             opacidade e rotacao, nao um v-if que pisca. -->
        <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <g class="theme-toggle-sun">
                <circle cx="10" cy="10" r="3.6" stroke="currentColor" stroke-width="1.5" />
                <g stroke="currentColor" stroke-width="1.5" stroke-linecap="round">
                    <path d="M10 1.6v1.8" />
                    <path d="M10 16.6v1.8" />
                    <path d="M1.6 10h1.8" />
                    <path d="M16.6 10h1.8" />
                    <path d="M4.05 4.05l1.28 1.28" />
                    <path d="M14.67 14.67l1.28 1.28" />
                    <path d="M15.95 4.05l-1.28 1.28" />
                    <path d="M5.33 14.67l-1.28 1.28" />
                </g>
            </g>
            <path class="theme-toggle-moon"
                d="M16.5 11.4A7 7 0 0 1 8.6 3.5a7 7 0 1 0 7.9 7.9Z"
                stroke="currentColor"
                stroke-width="1.5"
                stroke-linejoin="round" />
        </svg>
    </button>
</template>

<script>
import { isDarkTheme, toggleTheme } from '@/utils/services/ThemeService'

export default {
    name: 'ThemeToggleCmp',
    computed: {
        isDark() {
            // isDarkTheme le o themeState (Vue.observable), entao o computed reage a troca
            return isDarkTheme()
        },
        label() {
            return this.isDark ? 'Mudar para o tema claro' : 'Mudar para o tema escuro'
        },
    },
    methods: {
        toggle() {
            toggleTheme()
        },
    },
}
</script>

<style lang="scss" scoped>
.theme-toggle {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    padding: 0;
    color: var(--text-muted);
    background: transparent;
    border: 0;
    border-radius: 50%;
    cursor: pointer;
    transition: color .15s ease, background-color .15s ease, transform .2s ease;

    svg {
        width: 22px;
        height: 22px;
        overflow: visible;
    }

    &:hover,
    &:focus-visible {
        color: var(--brand);
        background-color: var(--tint-brand-bg);
    }

    &:active {
        transform: scale(.94);
    }

    &:focus {
        outline: none;
    }

    &:focus-visible {
        box-shadow: 0 0 0 3px var(--focus-ring);
    }
}

.theme-toggle-sun,
.theme-toggle-moon {
    transform-origin: center;
    transform-box: fill-box;
    transition: opacity .25s ease, transform .35s cubic-bezier(.4, 0, .2, 1);
}

/* O sol e ambar nos dois estados do botao (inclusive no hover): e o respiro de cor
   do topo. A lua segue a cor do botao, e e isso que da o contraste entre os dois. */
.theme-toggle-sun {
    color: var(--icon-highlight);
}

/* Claro: sol visivel. Escuro: lua. O estado vem do themeState, nao de `html.dark`. */
.theme-toggle-moon {
    opacity: 0;
    transform: rotate(-70deg) scale(.6);
}

.theme-toggle.is-dark {
    .theme-toggle-sun {
        opacity: 0;
        transform: rotate(70deg) scale(.6);
    }

    .theme-toggle-moon {
        opacity: 1;
        transform: none;
    }
}

@media (prefers-reduced-motion: reduce) {
    .theme-toggle,
    .theme-toggle-sun,
    .theme-toggle-moon {
        transition: none;
    }
}
</style>
